import { getViemClients, } from "@bracket/contractor-next";
import type { Config } from "@wagmi/core";

import {
	getContractWithABI,
	getTokenDefinition,
	isAddress,
	isBlockHash,
	type Address,
	type BlockHash,
	type ValidChainId,
} from "@bracket/chainography";




export declare type ClaimManagerFeesProps = {
	/** Address for the subject vault */
	vault: string;
	chainId?: ValidChainId;
	config?: Config;
};


export const claimManagerFees = async ({
	vault,
	chainId = 1,
	config,
}: ClaimManagerFeesProps): Promise<BlockHash> => {
	try {

		if(chainId !== 1)
			throw new Error("claimManagerFees supports only chain 1");

		if(!isAddress(vault))
			throw new Error("invalid vault address provided.");

		const [pub, priv] = await getViemClients({ chainId, config, });
		const [__, abi] = getContractWithABI("BracketVaultV2");

		const {
			request,
			result,
		} = await pub.simulateContract({
			address: vault,
			abi,
			functionName: "claimManagerFees",
			account: priv.account.address,
		})

		const hash = await priv.writeContract(request);
		await pub.waitForTransactionReceipt({ hash, timeout: 60_000, });
		if(isBlockHash(hash)) {
			return hash;
		}

		throw new Error("claimManagerTvlFees failed to produce a valid request");
	} catch (err) {

		throw new Error(`@bracket/chainography/BracketVaultV2:claimManagerTvlFees failed - ${err.message}`);
	}
};
